// Import modules
import './modules/navigation';
import './modules/animation/headerAnimation';
import './modules/sections/homeSections';
import initProjectImageHover from './modules/sections/projectImageHover';
import initClock from './modules/clock';

// Initialize site
document.addEventListener('DOMContentLoaded', () => {
  initClock();
  initProjectImageHover();
}); 